
import Pickaday from 'pikaday';
import moment from 'moment';

export class Datepicker {
    /**
    * Creates a new instance of the Video class for handling HTML5 Video, Youtube Videos and 23Videos
    * @param {HTMLElement} element Video DOM element
    */
    constructor (element) {
        // Name, reference
        element.Datepicker = this;

        // Elements
        this.el = element;
        this.icon = element.nextElementSibling;
        this.settings = { ...this._settings, ...JSON.parse(this.el.dataset.datepicker) };
        this.dateChanged = false;

        //Disable non working days
        if (this.settings.disableDays) {
            this.settings.disableDayFn = date => {
                if (this.settings.disableDays.includes(moment(date).format("YYYY-MM-DD"))) {
                    return true;
                }
                return false;
            };
        }

        // Date management
        if(this.settings.minDate) {
            this.settings.minDate = new Date(this.settings.minDate);
        }

        if(this.settings.maxDate) {
            this.settings.maxDate = new Date(this.settings.maxDate);
        }

        // Initiate
        this.instance = new Pickaday(this.settings);
        let value = this.el.value;
        let date = new Date();

        // Date range
        if(!this.settings.preventDefault && !value.length) {
            if(parseInt(this.settings.dateRange) > 0) {
                date.setDate(date.getDate() - this.settings.dateRange);
            }
            this.instance.setDate(date);
        }

        // State
        this.settings.isLoaded = true;

        // Events
        this.icon.addEventListener('click', () => this.instance.show());
        this.el.addEventListener('setMinDate', this._setMinDate.bind(this));
        this.el.addEventListener('setMaxDate', this._setMaxDate.bind(this));
    }

    /**
     * OnSelect
     * When a user selects a date from the datepicker, callback to see what needs to change
     */
    _onSelect () {
        if(!this.settings.isLoaded) { return; }

        // Ordersearch
        const oOrderSearch = document.getElementById('order-search');
        // Only update if date has changed
        if(oOrderSearch != null && this.dateChanged) {
            const oButton = oOrderSearch.querySelector('.js-order-search-trigger');
            if(oButton != null) oButton.click();
        }
    } 

    _setMinDate(e) {
        var minDate = e.detail?.date;
        if (!minDate) return;
        if (minDate.getFullYear().toString().length == 2) {
            minDate.setFullYear('20'.concat(minDate.getFullYear()));
        }
        this.instance.setMinDate(minDate);
    }

    _setMaxDate(e) {
        var maxDate = e.detail?.date;
        if (!maxDate) return;
        if (maxDate.getFullYear().toString().length == 2) {
            maxDate.setFullYear('20'.concat(maxDate.getFullYear()));
        }
        this.instance.setMaxDate(maxDate);
    }

    /**
     * Settings
     * Default settings from datepicker
     * @returns Object
     */
    get _settings () {
        return {
            field: this.el,
            firstDay: 1,
            dateRange: 0,
            format: 'MM-DD-YY',
            preventDefault: false,
            i18n: {
                previousMonth : '',
                nextMonth     : '',
                months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
                weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
                weekdaysShort : ['S','M','T','W','T','F','S']
            },
            onSelect: () => { this.dateChanged = true; },
            onClose: () => { this._onSelect(); },
            isLoaded: false
        }
    }
}
